function modalCtaAction() {
  const owdModal = document.querySelector('.owd-cta-modal');
  if (!owdModal) {
    return;
  }
  const closeButton = owdModal.querySelector('.owd-cta-modal-close');
  const modalAppDlLink = owdModal.querySelector('.owd-cta-modal-link');

  const openModal = (triggerButton) => {
    if (modalAppDlLink && triggerButton.href) {
      modalAppDlLink.href = triggerButton.href;
    }
    owdModal.classList.add("is-show");
    document.body.style.overflow = 'hidden';
    const pageTopButton = document.querySelector(".owd-button-pagetop-wrap");
    if (pageTopButton) pageTopButton.style.display = "none";
  };

  const closeModal = () => {
    owdModal.classList.remove("is-show");
    document.body.style.overflow = '';
    const pageTopButton = document.querySelector(".owd-button-pagetop-wrap");
    if (pageTopButton) pageTopButton.style.display = "block";
  };

  // イベント委譲：document全体でクリックを監視
  document.addEventListener('click', (e) => {
    // クリックされた要素が .is-owd-ctaModal-trigger またはその子要素かを確認
    const triggerButton = e.target.closest('.is-owd-ctaModal-trigger');
    if (!triggerButton) return;

    e.preventDefault(); // <a>タグのデフォルトの遷移を常に無効化

    if (window.innerWidth > 430) {
      // PC幅の場合はモーダルを表示
      openModal(triggerButton);
    } else {
      // SP幅の場合は直接リンク先に遷移（別タブで開く）
      window.open(triggerButton.href, '_blank', 'noopener');
    }
  });

  if (closeButton) closeButton.addEventListener('click', closeModal);
  owdModal.addEventListener('click', (e) => {
    if (e.target === owdModal) closeModal();
  });
}

export {modalCtaAction}
